import 'styles/globals.css';
import 'styles/global.scss';
import 'styles/button.css';
import 'styles/image-field.css';
import 'styles/text-field.css';
import 'styles/text-caption.css';
import 'styles/breadcrumbs.css';
import 'styles/pagination.css';
import 'styles/pinfield.css';
import 'styles/calendar.css';
import 'styles/heading.css';
import 'styles/toggle.scss';
import 'styles/style.css';
import 'styles/media-print.css';
import 'styles/drop-file-input.css';
import 'tailwindcss/tailwind.css';
import Intercom from 'react-intercom';

import { wrapper } from '../redux/store'; // store redux
import { useEffect, useState, useCallback } from 'react';
import { useRouter } from 'next/router';
import { Progress } from 'components/molecules/Progress';
import { getAccount } from 'services/account';
import { getActivate } from 'services/register';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const [isAnimating, setIsAnimating] = useState(false);
  const [user, setUser] = useState({
    name: '',
    email: '',
  });

  const getAccountAPI = useCallback(async () => {
    const response = await getAccount();
    if (response.error) {
      console.log('response.error >>>');
      console.log(response.error);
    } else {
      setUser({
        ...user,
        name: response?.data?.data?.name,
        email: response?.data?.data?.email,
      });
    }
  }, []);

  useEffect(() => {
    getAccountAPI();
  }, []);

  useEffect(() => {
    const handleStart = () => {
      setIsAnimating(true);
    };
    const handleStop = () => {
      setIsAnimating(false);
    };
    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);

  useEffect(() => {
    // check if user not activate the account
    getActivate().then((activate) => {
      if (!activate.error) {
        if (
          (activate.data.data.showActivationPage && router.pathname === '/location/location') ||
          (activate.data.data.showActivationPage && router.pathname === '/')
        ) {
          window.location.href = '/registration/activate';
        }
      } else {
        console.log(activate);
      }
    });

    // check if user type not root, they can't redirect to hub
    let _userType = localStorage.getItem('userType');
    if (_userType === 'USER' && router.pathname === '/location/location') {
      window.location.href = '/subscription-sales/basic-sales/product';
    }
    if (_userType === 'USER' && router.pathname === '/') {
      window.location.href = '/subscription-sales/basic-sales/product';
    }

    // home page in hub not ready, redirect to location
    if (router.pathname === '/') {
      router.push('/location');
    }
  }, []);

  // console.log(router.pathname);

  return (
    <div className="relative">
      {router.pathname !== '/ordering/product' ||
      router.pathname !== '/ordering/checkout' ||
      router.pathname !== '/plans' ||
      router.pathname !== '/registration' ? (
        <Intercom appID="otdd44zy" {...user} />
      ) : (
        ''
      )}
      <Progress isAnimating={isAnimating} />

      <Component {...pageProps} />
    </div>
  );
}

export default wrapper.withRedux(MyApp);
